import { GroupByOption } from "../../context/DateDropdownContext";

export type StoreOverviewCardsRequestParams = {
  from: string;
  to: string;
  prevStartDate?: string;
  prevEndDate?: string;
  storeId: string | undefined;
  customerId: string | undefined;
  accountId: string | undefined;
  managerCustomerId: string | undefined;
  groupBy?: GroupByOption;
  baseCurrency?: string;
  targetCurrency?: string;
};

const getEndpointParams = ({
  from,
  to,
  prevStartDate,
  prevEndDate,
  storeId,
  customerId,
  accountId,
  managerCustomerId,
  groupBy,
  baseCurrency,
  targetCurrency,
}: StoreOverviewCardsRequestParams) => {
  let params = `?storeId=${storeId}&managerCustomerId=${managerCustomerId}&customerId=${customerId}&accountId=${accountId}&startDate=${from}&endDate=${to}&groupBy=${groupBy}&baseCurrency=${baseCurrency}&targetCurrency=${targetCurrency}`;

  if (prevStartDate && prevEndDate) {
    params = params.concat(`&prevStartDate=${prevStartDate}&prevEndDate=${prevEndDate}`);
  }

  return params;
};

const ENDPOINTS = {
  overviewCards: {
    dataForPeriod: (payload: StoreOverviewCardsRequestParams) =>
      `/api/store/overview${getEndpointParams(payload)}`,
  },
  spotlight: {
    dataForPeriod: (payload: StoreOverviewCardsRequestParams) =>
      `/api/store/spot-light${getEndpointParams(payload)}`,
  },
  topcountriesregions: {
    dataForPeriod: ({ storeId, from, to }: { storeId: string; from: string; to: string }) =>
      `/api/store/orders/top-countries-region?storeId=${storeId}&startDate=${from}&endDate=${to}`,
  },
};

export { ENDPOINTS };
